export const chefInfo = {
  name: "Mete",
  title: "Private Chef",
  photo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_mete-gourmet/artifacts/laz3v5jb_ben%20b%C4%B1g%20chef.webp",
  location: "Private Chef covering Stoke-on-Trent, Manchester and surrounding areas.",
  tagline: "Unforgettable flavours in the comfort of your own home. Tailored culinary experiences for all occasions, blending Turkish and international cuisines to perfection.",
  intro: "From vibrant chef's snacks to beautifully presented courses, every dish is tailored to your tastes, dietary needs and the atmosphere you want to create. Whether you're hosting an intimate celebration or a special gathering, I bring the passion and professionalism that turn great meals into unforgettable moments.",
  availability: "Available for bookings: Private Dining | Chef Cover | Events | Takeovers & Pop-ups | Personal Chef and more",
  established: "ESTD 2024",
  email: "Durmaz@privatechefmete.net",
  phone: "+44 7443 667570",
  whatsapp: "447443667570",
  website: "privatechefmete.net",
  instagram: "https://instagram.com/private_chef_mete",
  instagramHandle: "@private_chef_mete"
};

export const howItWorks = [
  {
    id: "how-01",
    step: "01",
    title: "Consultation",
    text: "We begin by understanding your preferences, dietary needs and event requirements."
  },
  {
    id: "how-02",
    step: "02",
    title: "Menu Creation",
    text: "A bespoke menu is tailored to suit your occasion and taste."
  },
  {
    id: "how-03",
    step: "03",
    title: "Cooking",
    text: "Using the finest ingredients, we prepare meals with care and expertise."
  },
  {
    id: "how-04",
    step: "04",
    title: "Service",
    text: "Impeccable presentation and service, whether at your table or for your guests."
  }
];

export const whyChooseUs = [
  {
    id: "why-01",
    title: "Customized Menus",
    text: "Every menu is designed to meet your unique tastes and needs."
  },
  {
    id: "why-02",
    title: "Fresh Ingredients",
    text: "We use locally sourced and seasonal produce for every dish."
  },
  {
    id: "why-03",
    title: "Artful Presentation",
    text: "Your meals will not only taste amazing but also look stunning."
  },
  {
    id: "why-04",
    title: "Global & Turkish Cuisine",
    text: "A harmonious fusion of local and international flavours."
  }
];

export const specialOffer = {
  title: "Special Offer",
  headline: "50% off your initial service",
  text: "Book your first consultation and receive 50% off your initial service. Planning a romantic dinner for your partner? Don't miss this chance to create an unforgettable evening."
};

export const heroImage = "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nJTIwcGxhdGVkJTIwZGlzaHxlbnwwfHx8fDE3ODI5Mzk5OTh8MA&ixlib=rb-4.1.0&q=85";

export const aboutImage = "https://images.unsplash.com/photo-1758892170660-3ad271f3d672?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwY2hlZiUyMGtpdGNoZW58ZW58MHx8fHwxNzgyOTM5OTk4fDA&ixlib=rb-4.1.0&q=85";

export const experienceImage = "https://images.unsplash.com/photo-1643879397174-4f10ac503566?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxmaW5lJTIwZGluaW5nJTIwcGxhdGVkJTIwZGlzaHxlbnwwfHx8fDE3ODI5Mzk5OTh8MA&ixlib=rb-4.1.0&q=85";

export const services = [
  {
    id: "svc-freelance",
    title: "FREELANCE CHEF",
    subtitle: "Kitchen brigade cover across all roles",
    items: [
      "Head Chef, Sous, CDP and Commis cover",
      "Short-notice sick & holiday relief",
      "Lead-role cover until you recruit",
      "Fully DBS checked, Level 3 Food Safety"
    ],
    image: "https://images.unsplash.com/photo-1600663791817-d74f5196ba29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxGcmVuY2glMjBjdWlzaW5lfGVufDB8fHx8MTc4Mjk0MDAwNXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "svc-popups",
    title: "TAKEOVERS & POP-UPS",
    subtitle: "Bring a new concept to your kitchen",
    items: [
      "Collaborations with existing brigades",
      "Festival & outdoor pop-ups",
      "Takeovers of vacant kitchens",
      "Menu design, costing & execution"
    ],
    image: "https://images.unsplash.com/photo-1598214928052-185e72192688?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwZm9vZCUyMHBob3RvZ3JhcGh5fGVufDB8fHx8MTc4MjkzOTk5OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "svc-private-dining",
    title: "PRIVATE DINING",
    subtitle: "Restaurant experience in your home",
    items: [
      "Bespoke tasting menus (3\u20137 courses)",
      "All shopping, prep and service included",
      "Kitchen left spotless afterwards",
      "Sommelier & FOH team on request"
    ],
    image: "https://images.unsplash.com/photo-1629272040444-2f7553ec7466?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwZm9vZCUyMHBob3RvZ3JhcGh5fGVufDB8fHx8MTc4MjkzOTk5OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "svc-events",
    title: "EVENTS & WEDDINGS",
    subtitle: "From 20 to 300+ guests",
    items: [
      "Full-service wedding catering",
      "Canap\u00e9 receptions & sit-down menus",
      "All dietary requirements catered for",
      "Tasting session before the day"
    ],
    image: "https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxCQlElMjBzbW9rZWhvdXNlJTIwbWVhdHxlbnwwfHx8fDE3ODI5NDAwMDV8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "svc-consultancy",
    title: "KITCHEN CONSULTANCY",
    subtitle: "Operational uplift for your venue",
    items: [
      "EHO 5-star Health & Safety audits",
      "Menu structure, pricing & concepts",
      "GP targets & stock control",
      "Staffing & rota optimisation"
    ],
    image: "https://images.unsplash.com/photo-1758892170660-3ad271f3d672?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwY2hlZiUyMGtpdGNoZW58ZW58MHx8fHwxNzgyOTM5OTk4fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const servicesList = [
  "Freelance Chef Cover / Relief",
  "Takeovers and Pop-Up Events",
  "Private Dining",
  "Events - including Weddings",
  "Charity Events",
  "Menu Consultancy / Advice",
  "Kitchen Function Consultancy",
  "Health & Safety Advice",
  "Training"
];

export const testimonials = [
  {
    id: "tst-01",
    text: "Mete catered our wedding in Cheshire last summer for 110 guests and honestly the food was the talk of the day. He worked with us for months beforehand to tailor a 3-course menu that balanced classic British flavours with Mediterranean touches. Vegan and gluten-free guests were looked after brilliantly. Calm, warm and completely on top of every detail.",
    author: "Chris & Michelle Nelson",
    role: "Wedding, Nantwich",
    rating: 5
  },
  {
    id: "tst-02",
    text: "We booked Mete for a private dinner at home for my husband's 40th. Eight of us round the table and it felt like a proper Michelin experience in our own dining room. The beef fillet with bone marrow crumb was extraordinary. He cleaned everything up before he left too.",
    author: "Sarah Whitmore",
    role: "Private Dining, Alderley Edge",
    rating: 5
  },
  {
    id: "tst-03",
    text: "Mete came in as head chef cover for three weeks while our lead was off. He walked into a busy kitchen, learned our menu inside a shift and delivered consistent, high quality plates every service. He also spotted a couple of GP improvements we've kept in place ever since.",
    author: "Dax Robateau",
    role: "Operations Manager, Stoke-on-Trent",
    rating: 5
  },
  {
    id: "tst-04",
    text: "Hired Mete for a pop-up supper club and he absolutely delivered. Six courses, 32 covers, all sent out on time and looking beautiful. Guests were raving about the smoked lamb course for weeks after. Already booked him for the next one.",
    author: "James Holloway",
    role: "Pop-Up Event, Sheffield",
    rating: 5
  },
  {
    id: "tst-05",
    text: "Mete catered our corporate away-day dinner (28 people, mixed dietary requirements including two nut allergies and a coeliac). The whole team is still talking about the short rib and the dessert board. Professional, well-priced and honestly a joy to deal with.",
    author: "Rebecca Owens",
    role: "Corporate Event, Wilmslow",
    rating: 5
  },
  {
    id: "tst-06",
    text: "Booked Mete for my parents' 50th anniversary. He designed a menu around dishes that meant something to them, walked mum through the wine pairings and even hand-wrote the menus. My dad said it was the best meal he's had in years. High praise from a former butcher!",
    author: "Oliver Barnes",
    role: "Anniversary Dinner, Chester",
    rating: 5
  },
  {
    id: "tst-07",
    text: "We had Mete cover a two-week gap for our sous chef at short notice. He picked up the pass by service two and honestly ran a tighter section than we're used to. Bookings would come back to us saying the food had never been better. Would use him again in a heartbeat.",
    author: "Harriet Fletcher",
    role: "Head Chef, Manchester",
    rating: 5
  },
  {
    id: "tst-08",
    text: "Christening lunch for 45 in our garden. Marquee, temperamental weather, the works. Mete brought a small team, set up a whole outdoor kitchen and delivered a three-course lunch that felt like a proper restaurant. Even the grandparents were impressed, which is saying something.",
    author: "Thomas & Emily Grant",
    role: "Christening, Congleton",
    rating: 5
  },
  {
    id: "tst-09",
    text: "As a supper-club organiser I've worked with dozens of chefs. Mete is genuinely up there with the best. Cost management is sharp, execution is precise and guests actually remember the food afterwards, which is the real test.",
    author: "Marcus Reid",
    role: "Supper Club, Leeds",
    rating: 5
  },
  {
    id: "tst-10",
    text: "Engagement party for 60 at a country house near us. Grazing canapés, sit-down mains, sharing puddings. Everything landed on time and looked stunning. Mete's a lovely bloke on top of being a brilliant chef, which made the whole day easier.",
    author: "Laura Pemberton",
    role: "Engagement Party, Knutsford",
    rating: 5
  },
  {
    id: "tst-11",
    text: "Christmas dinner for the whole family, 14 of us. I usually spend the day sweating in the kitchen — this year I actually sat down and enjoyed it. Turkey was properly cooked, the beef alternative was excellent and the trimmings were next level. Booked in again for next year.",
    author: "Alistair MacDonald",
    role: "Christmas Dinner, Macclesfield",
    rating: 5
  },
  {
    id: "tst-12",
    text: "Ran a pop-up at our venue for one weekend and doubled our covers versus a normal weekend. Mete costed the menu, ran the pass and even helped train two of our kitchen porters up. Genuine consultant-level input, not just a chef for hire.",
    author: "Naomi Clarke",
    role: "Venue Owner, Derby",
    rating: 5
  },
  {
    id: "tst-13",
    text: "60th birthday dinner at home, 12 guests, seven courses. Mete kept it playful — a proper amuse-bouche, a fun palate cleanser and a cheese course that stole the show. Two vegetarians and one pescatarian, all completely looked after. Excellent value for what he delivered.",
    author: "Jonathan Ellis",
    role: "Birthday Dinner, Buxton",
    rating: 5
  },
  {
    id: "tst-14",
    text: "Had Mete in for a full kitchen consultancy — menu costs, rota structure, ordering. Within a month our food GP was up 6% and the team were less stressed. Straightforward, practical advice and no ego about it.",
    author: "Priya Malik",
    role: "Restaurant Owner, Nottingham",
    rating: 5
  },
  {
    id: "tst-15",
    text: "Small intimate wedding, just 22 of us in a barn conversion. Mete built a menu around locally sourced ingredients and Mediterranean influences. The lamb was cooked to absolute perfection. Guests are still messaging us about the food.",
    author: "Freya Sinclair",
    role: "Wedding, Bakewell",
    rating: 5
  },
  {
    id: "tst-16",
    text: "Team dinner for our directors, ten covers, quite a formal brief. Mete produced a menu that felt considered and grown-up, plated everything beautifully and worked the room brilliantly at the end. The kind of chef you can put in front of clients.",
    author: "Daniel Whittaker",
    role: "Director Dinner, Warrington",
    rating: 5
  },
  {
    id: "tst-17",
    text: "Booked as chef cover during a busy summer at our gastropub. Mete slotted into the brigade immediately, no drama, no ego. Consistent execution across a demanding menu, and the KP team actually liked him — which almost never happens with agency chefs.",
    author: "Steve Ashworth",
    role: "Head Chef, Liverpool",
    rating: 5
  },
  {
    id: "tst-18",
    text: "Fundraiser dinner for a local charity, 80 covers on a tight budget. Mete kept the costs sensible without compromising the plates. Raised more than we ever have before and the food was a big part of that. Warm, professional, generous with his time.",
    author: "Helen Ashford",
    role: "Charity Event, Shrewsbury",
    rating: 5
  },
  {
    id: "tst-19",
    text: "Baby shower brunch for 30, and the brief was 'nothing dry, nothing boring'. Delivered on both. Sharing boards, hot bites, a really good little dessert selection. Mete handled two coeliacs and a vegan without them feeling like an afterthought.",
    author: "Charlotte Prescott",
    role: "Baby Shower, Leek",
    rating: 5
  },
  {
    id: "tst-20",
    text: "We used Mete for a supplier appreciation lunch. Twelve guests, needed to impress. He curated a menu around British ingredients, talked the guests through each course and honestly represented our brand better than we could have. Booked him for the next one already.",
    author: "Ryan Bakshi",
    role: "Corporate Lunch, Birmingham",
    rating: 5
  },
  {
    id: "tst-21",
    text: "Rehearsal dinner the night before our wedding, 24 people, in a very tight window. Mete pulled it off flawlessly and it set the tone for the whole weekend. Everyone showed up hungry the next day because they knew what was coming.",
    author: "Amelia Rushton",
    role: "Rehearsal Dinner, Harrogate",
    rating: 5
  },
  {
    id: "tst-22",
    text: "Retirement do for my dad, 40 close family and colleagues. Mete produced a proper hearty menu — belly pork, dauphinoise, a beautiful sticky toffee pudding. Dad was in tears (in a good way). Cannot fault a single thing.",
    author: "Louise Hartley",
    role: "Retirement Party, Preston",
    rating: 5
  },
  {
    id: "tst-23",
    text: "Dinner party for a friend's milestone birthday. Mete arrived early, was completely unobtrusive, produced five courses that looked like they'd come out of a fine dining restaurant and left the kitchen cleaner than he found it. Excellent value.",
    author: "Simon Whitaker",
    role: "Private Dining, York",
    rating: 5
  },
  {
    id: "tst-24",
    text: "Booked Mete for our engagement lunch, 18 guests, mixed backgrounds and dietary needs. The Mediterranean-meets-British menu he put together was thoughtful and full of flavour. Guests were coming up to him at the end just to say thank you. Class act.",
    author: "Olivia Barrington",
    role: "Engagement Lunch, Cheltenham",
    rating: 5
  },
  {
    id: "tst-25",
    text: "Hired Mete to cover our head chef spot for a month during a rebrand. He walked into a tricky situation and settled the whole kitchen down within the first week. Our covers went up, complaints went to zero. Genuinely one of the most reliable chefs we've worked with.",
    author: "Owen Radcliffe",
    role: "Restaurant Manager, Leicester",
    rating: 5
  }
];

export const stats = [
  { number: "15+", label: "YEARS EXPERIENCE" },
  { number: "200+", label: "EVENTS CATERED" },
  { number: "4.9\u2605", label: "AVERAGE RATING" },
  { number: "100%", label: "REPEAT CLIENTS" }
];

export const pricing = [
  {
    id: "pkg-01",
    name: "Private Dining",
    from: "\u00a375",
    unit: "per person",
    highlights: [
      "3-course tasting menu",
      "Chef on-site cooking & service",
      "All shopping & prep included",
      "Full kitchen clean-down"
    ],
    note: "Minimum 6 guests. Bespoke menus available."
  },
  {
    id: "pkg-02",
    name: "Events & Weddings",
    from: "\u00a355",
    unit: "per person",
    highlights: [
      "Canap\u00e9s + 2 or 3-course menu",
      "Team of chefs & FOH available",
      "Full dietary management",
      "Site visit & tasting included"
    ],
    note: "Tailored quote for 40+ guests.",
    featured: true
  },
  {
    id: "pkg-03",
    name: "Chef Cover",
    from: "\u00a320",
    unit: "per hour",
    highlights: [
      "Head chef / sous / CDP cover",
      "Sick & holiday relief",
      "Short-notice availability",
      "Fully DBS checked & insured"
    ],
    note: "Day rates available on request."
  }
];
